import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import { getAreas } from '../../constants/markers';

const TourAreaList = () => {
  let navigate = useNavigate();
  let { tour, area: activeArea } = useParams();

  const updateArea = (event) => {
    const areaName = event.target.value;
    navigate(`/maps/${tour}/${areaName}/`);
  };

  const areas = getAreas(tour, activeArea);
  return (
    <Box sx={{ minWidth: 120, padding: '0 9px' }}>
      <FormControl fullWidth>
        <NativeSelect
          defaultValue={activeArea}
          value={activeArea}
          inputProps={{
            name: 'area',
            id: 'uncontrolled-native',
          }}
          onChange={updateArea}
        >
          {areas.map((area) => {
            const { area: areaName } = area;
            return (
              <option key={areaName} value={areaName}>
                {areaName}
              </option>
            );
          })}
        </NativeSelect>
      </FormControl>
    </Box>
  );
};

export default TourAreaList;
